import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { injectModels } from "../../../redux/injectModels";
import { AuthService, TraderUnitService } from "../../../services";

import {
  formatAmount,
  handleConsoleError,
} from "../../../utils/common-methods";
import { toast } from "react-toastify";

const TraderUnitShopfrontMapping = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [shopFronts, setShopFrontsData] = useState([]);
  const selectedUnit = TraderUnitService.getSelectedTraderUnit();

  // State to track selected images
  const [selectedItem, setSelectedItem] = useState([]);

  // Handle checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedItem((prevSelected) => {
      if (prevSelected.includes(id)) {
        // Remove the image from selected if already checked
        return prevSelected.filter((imageId) => imageId !== id);
      } else {
        // Add the image to selected if not already checked
        return [...prevSelected, id];
      }
    });
  };

  const getShopFrontData = async () => {
    try {
      props.application.setLoading(true);
      const res = await TraderUnitService.getTraderUnitShopfront(
        loginUser?.id,
        selectedUnit.id,
        false
      );
      if (res?.isSuccess && res?.data?.length > 0) {
        setShopFrontsData(res?.data);
      } else {
        setShopFrontsData([]);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleAddItem = async (e) => {
    e.preventDefault();
    try {
      const data = {
        unitId: selectedUnit.id,
        shopFrontProductIds: selectedItem,
      };
      props.application.setLoading(true);
      const res = await TraderUnitService.addTraderUnitShopfront(data);
      if (res?.isSuccess) {
        await getShopFrontData();
        props.onClose();
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getShopFrontData();
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <h3> Add Item to Unit Shop front </h3>
      </div>

      <section className="edit-form-table">
        <div className="container mt-3">
          <div
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              //   border: "1px solid #ccc",
            }}
          >
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Product Title</th>
                    <th>Description</th>
                    {/* <th>Image</th> */}
                    <th>Price</th>
                    {/* <th>Status</th>
                  <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {shopFronts.map((item) => (
                    <tr key={item?.id}>
                      <td>
                        {" "}
                        <input
                          type="checkbox"
                          checked={selectedItem.includes(item?.id)}
                          onChange={() => handleCheckboxChange(item?.id)}
                        />
                      </td>
                      <td>
                        {" "}
                        <span>{item?.productTitle}</span>
                      </td>
                      <td>
                        {" "}
                        <span>{item?.productDescription}</span>
                      </td>
                      <td>
                        {" "}
                        <span>£{formatAmount(item?.price)}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
          {/* <div>
            <h3>Selected Product:</h3>
            <ul>
              {selectedItem.map((id) => {
                const selectedItem = shopFronts.find((item) => item.id === id);
                return <li key={id}>{selectedItem.productTitle}</li>;
              })}
            </ul>
          </div> */}
          <div className="col-12 row">
            {/* <div className="col-6">
                    <div className="back-bt12 back1">
                      <span
                        onClick={(e) => handleBackButton(e)}
                        className="btn btn-primary"
                      >
                        Back
                      </span>
                    </div>
                  </div> */}
            <div className="col-6">
              <div className="back-bt12 back1">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={(e) => handleAddItem(e)}
                >
                  Add to unit
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TraderUnitShopfrontMapping);
